<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="rgba(12,213,240,0.54)" type="ball-atom"
  [fullScreen]="true">
  <p style="color: rgb(255, 255, 255)"> Loading... </p>
</ngx-spinner>
<!-- https://napster2210.github.io/ngx-spinner/ -->